import axios from 'axios';
import { nextTick } from 'vue';

export default {
    name: 'FormModal',
    props: {
        menuIcon: {
            type: String,
            required: true,
        },
        subHeadline: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        pdfUrl: {
            type: String,
            required: true,
        },
        pdfName: {
            type: String,
            required: true,
        },
        csrfTokenName: {
            type: String,
            required: true,
        },
        csrfTokenValue: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            modalOpen: false,
            formData: {
                name: '',
                email: '',
            },
            formSubmitted: false,
            errorMessage: '',
        };
    },
    methods: {
        toggleModal() {
            this.modalOpen = !this.modalOpen;
            this.formSubmitted = false;
            this.errorMessage = '';

            nextTick(() => {
                if (this.modalOpen) {
                    this.resetErrorState();
                }
            });
        },
        submitForm(event) {
            event.preventDefault();
            let hasErrors = false;

            if (!this.formData.name) {
                this.$refs.nameInput.classList.add('input-error');
                hasErrors = true;
            } else {
                this.$refs.nameInput.classList.remove('input-error');
            }

            if (!this.formData.email) {
                this.$refs.emailInput.classList.add('input-error');
                hasErrors = true;
            } else {
                this.$refs.emailInput.classList.remove('input-error');
            }

            if (hasErrors) {
                this.errorMessage = 'Please fill in all required fields!';
                return;
            }

            this.errorMessage = '';

            const data = new FormData();
            data.append('message[formName]', 'Gated Content');
            data.append('fromName', this.formData.name);
            data.append('fromEmail', this.formData.email);
            data.append('message[body]', 'This is a gated content request');
            data.append(this.csrfTokenName, this.csrfTokenValue);

            axios.post('/actions/contact-form/send', data)
                .then((response) => {
                    if (response.data.message === 'Your message has been sent.') {
                        this.formSubmitted = true;
                        this.downloadPDF();
                    }
                })
                .catch(() => {
                    this.errorMessage = 'There was an issue submitting your form. Please try again.';
                });
        },
        resetErrorState() {
            this.$refs.nameInput.classList.remove('input-error');
            this.$refs.emailInput.classList.remove('input-error');
        },
        clearError(refName) {
            this.$refs[refName].classList.remove('input-error');
        },

        downloadPDF() {
            const link = document.createElement('a');
            link.href = this.pdfUrl;
            link.setAttribute('download', this.pdfName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
    template: `
        <div v-if="modalOpen" class="modal-overlay">
            <div class="modal-content">
                <div class="modal-close-wrapper">
                    <span @click="toggleModal" class="modal-close-btn" v-html="menuIcon"></span>
                </div>
                <div class="modal-text-container">
                    <h2 class="modal-subheadline">{{ subHeadline }}</h2>
                    <p class="modal-text">{{ text }}</p>
                </div>
                <form @submit="submitForm" class="form" v-if="!formSubmitted">                
                    <div class="modal-input">
                        <input type="text" v-model="formData.name" placeholder="Name" ref="nameInput" 
                        @input="clearError('nameInput')">
                    </div>
                    <div class="modal-input">
                        <input type="email" v-model="formData.email" placeholder="Email" ref="emailInput" 
                        @input="clearError('emailInput')">
                        <button type="submit" class="modal-submit-btn">
                            <span class="modal-dl-span">DOWNLOAD</span>
                            <i class="app-icon-chevron-right-bold modal-download-icon"></i>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    `,
};
